export function await_next_tick(): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => resolve(), 0);
  });
}
